import TableRow from './TableRow';
import { TableRowProps, TableRowValueProps } from './types';

export type { TableRowProps, TableRowValueProps };
export default TableRow;
